import React from 'react'
import { useAuth } from '../../context/AuthContext'
import { Fade } from "react-awesome-reveal";
import SeoHeader from "./SeoHeader";
import { NavLink, Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { greeting, settings } from "../../../portfolio";
import {ThemeProps} from "../../styles/themeprops";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from "react-i18next";

type NavbarProps = {
  children?: React.ReactNode;
  theme:ThemeProps
};

const onMouseEnter = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, color:string) => {
  const targetElem = (event.target as HTMLInputElement);
  targetElem.style.backgroundColor = color;
};

const onMouseOut = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  const targetElem = (event.target as HTMLInputElement);
  targetElem.style.backgroundColor = "transparent";
};
const onClickLang = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,i18n:any) => {
	event.preventDefault();
  const targetElem = (event.target as HTMLInputElement);
  i18n.changeLanguage(targetElem.getAttribute("id"));
};


export default function Navbar({
  children,
  theme,
}: NavbarProps):JSX.Element  {

  const { getUser, userIsAuthenticated, userLogout } = useAuth()

  const logout = () => {
    userLogout()
  }

  const enterMenuStyle = () : string => {
    return userIsAuthenticated() ? "none" : "block" 
  }

  const logoutMenuStyle = () : string => {
    return userIsAuthenticated() ? "block":"none"
  }

  const adminPageStyle = () : string => {
    const user = getUser()
    return user && user.data.rol[0] === 'ADMIN' ?  "block" : "none"
  }

  const userPageStyle = () : string => {
    const user = getUser()
    return user && user.data.rol[0] === 'USER' ? "block":"none"
  }

  const getUserName = () => {
    const user = getUser()
    return user ? user.data.name : ''
  }
  const link = settings.isSplash ? "/splash" : "/home";
  const themeVar = {theme};
  const { t,i18n } = useTranslation();
  return (
      <header className="header">
        <NavLink to={link} className="logo">
					<span style={{ color: themeVar.theme.text }}> &lt;</span>
          <span className="logo-name" style={{ color: themeVar.theme.text }}>
            {greeting.logo_name}
          </span>
          <span style={{ color: themeVar.theme.text }}>/&gt;</span>
        </NavLink>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className="navicon"></span>
        </label>
        
        <ul className="menu" style={{ backgroundColor: themeVar.theme.body }}>
          <li>
            <NavLink
              to="/home"
              className={({ isActive }) => ['nav-link',isActive ? 'active' : null,].filter(Boolean).join(" ")}
              style={{ color: themeVar.theme.text }}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/education"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text }}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
            {t("education")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/experience"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text }}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              {t("experience")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text,display: enterMenuStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              {t("contact")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/userpage"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text, display: userPageStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              <span>
	              UserPage
	          </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/adminpage"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text, display: adminPageStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              <span>
	              <i className="fas "></i>Admin
	          </span>
            </NavLink>
          </li>
          <li className="nav-item dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				    <a className="nav-link dropdown-toggle" id="navbarDropdown" role="button" style={{ color: themeVar.theme.text, display: logoutMenuStyle(),}}
				    	onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
				    	data-bs-toggle="dropdown" aria-expanded="false">
				    	<i className="fas"></i>{`Hi ${getUserName()}`}
				    </a>
          	<ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li>
                	<a className="dropdown-item" href="#" 
                		onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
          					onMouseOut={(event) => onMouseOut(event)}>Action</a>
          			</li>
                <li><a className="dropdown-item" href="#" onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)} 
                	onMouseOut={(event) => onMouseOut(event)}>Another action</a></li>
                <li><a className="dropdown-item" href="#" onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
          			onMouseOut={(event) => onMouseOut(event)}>Another actionasdf</a></li>
                <li>
                	<NavLink to="/" className={({ isActive }) => isActive ? 'linkActive dropdown-item' : 'dropdown-item'} 
			              style={{ color: themeVar.theme.text, display: logoutMenuStyle()}}
			              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
			              onMouseOut={(event) => onMouseOut(event)} onClick={logout}>
			              <span>
				              <i className="fa-solid fa-arrow-right-from-bracket"></i>
				          	</span>
			            </NavLink>
          			</li>
            </ul>
		  		</li>
          <li>
            <NavLink
              to="/login"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text, display: enterMenuStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              <OverlayTrigger
                  key="Sign in"
                  placement={"right"}
                  overlay={
                    <Tooltip id={`tooltip-top`}>
                      <strong style={{padding:10}}>{t("signin")}</strong>
                    </Tooltip>
                  }
                >
	              <i className="fa fa-regular fa-circle-user"></i>
	          </OverlayTrigger>
            </NavLink>
          </li>
          
          <li>
            <NavLink
              to="#"
              className={({ isActive }) => isActive ? '' : ''} 
              style={{ color: themeVar.theme.text,display: enterMenuStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
              onClick={(event) => onClickLang(event,i18n)}
              id={i18n.language=='de'?'en':'de'}
            >
              {i18n.language=='de'?'EN':'DE'}
            </NavLink>
          </li>
        </ul>
      </header>
  )
  
  /**
   * <li>
            <NavLink
              to="#"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text, display: logoutMenuStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
            >
              <span>
	              <i className="fas"></i>{`Hi ${getUserName()}`}
	          </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => isActive ? 'linkActive' : ''} 
              style={{ color: themeVar.theme.text, display: logoutMenuStyle()}}
              onMouseEnter={(event) => onMouseEnter(event, themeVar.theme.highlight)}
              onMouseOut={(event) => onMouseOut(event)}
              onClick={logout}
            >
              <span>
	              <i className="fa-solid fa-arrow-right-from-bracket"></i>
	          </span>
            </NavLink>
          </li> 
   */
}
